import { useContext } from "react";
import { AppContext } from "../App";

export default function CallToAction() {
  const appContext = useContext(AppContext);

  return (
    <section className="ags-cta-section">
      <div className="container">
        <div className="ags-cta-card">
          <div>
            <h5 className="mb-1 font-bold">
              Need assistance?
            </h5>
            <p className="mb-0">
              Contact our team and we will be happy to discuss your project
              requirements and recommend the most suitable geospatial solution.
            </p>
          </div>

          <button
            className="btn btn-light btn-rounded px-4"
            onClick={() => appContext.navTo({ item: "contact" })}
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}